import { Injectable } from '@angular/core';
import { isUndefined } from 'util';
import {
  ModalChatDetailComponent
} from '../components/chat-show/chat-detail/modal-chat-detail/modal-chat-detail.component';
import { ModalMapComponent } from '../components/chat-show/message/modal-map/modal-map.component';
import { ModalVideoCallsComponent } from '../components/modal-video-calls/modal-video-calls.component';
import { ChatDetailComponent } from '../components/chat-show/chat-detail/chat-detail.component';
import {
  ModalForwardMessageComponent
} from '../components/chat-show/modal-forward-message/modal-forward-message.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  ModalNotifySettingsComponent
} from '../components/chat-list/modal-notify-settings/modal-notify-settings.component';
import {
  ModalAddChatMemberComponent
} from '../components/chat-show/modal-add-chat-member/modal-add-chat-member.component';
import { ModalCopyTextComponent } from '../components/chat-show/message/modal-copy-text/modal-copy-text.component';
import { ModalAddAccountComponent } from '../pages/page-start/modal-add-account/modal-add-account.component';
import {
  ModalMessagePinnedComponent
} from '../components/chat-show/message/message-pinned/modal-message-pinned/modal-message-pinned.component';
import {
  ModalSerrosContactsComponent
} from '../components/chat-show/add-form-sender/modal-serros-contacts/modal-serros-contacts.component';
import { IMessengerConnector } from '../types/all.type';
import { ModalAddBalanceComponent } from '../components/chat-show/modal-add-balance/modal-add-balance.component';
import {
  ModalSenderRegisterComponent
} from '../pages/page-telegram/sign-telegram/modal-sender-register/modal-sender-register.component';
import { FaqParseComponent } from '../modules/sender/modals/faq/faq-parse/faq-parse.component';
import { SendLimitComponent } from '../modules/sender/modals/faq/send-limit/send-limit.component';
import { BanAccountsComponent } from '../modules/sender/modals/faq/ban-accounts/ban-accounts.component';
import { FaqPostComponent } from '../modules/sender/modals/faq/faq-post/faq-post.component';
import {
  LeadsScanTasksEditModalComponent
} from "../pages/page-leads/leads-scan-tasks-edit-modal/leads-scan-tasks-edit-modal.component";
import { ModalLeadsTariffComponent } from "../template/modals/modal-leads-tariff/modal-leads-tariff.component";
import { ModalFirstFaqVideoComponent } from '../template/modals/modal-first-faq-video/modal-first-faq-video.component';
import {
  ModalResultContactsComponent
} from "../components/chat-show/add-form-sender/modal-result-contacts/modal-result-contacts.component";

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  bsModalRef: BsModalRef;
  private arModals: any = [];

  constructor(private modalService: BsModalService) {
  }

  openModal(content, data: any = {}) {
    switch (content) {
      case 'ChatDetailComponent':
      case 'ModalChatDetailComponent':
        this.bsModalRef = this.modalService.show(
          ModalChatDetailComponent,
          Object.assign(
            {},
            {
              class: 'modal-md',
              ignoreBackdropClick: true,
              initialState: {
                data
              }
            }
          )
        );
        break;
      case 'ModalMapComponent':
        this.bsModalRef = this.modalService.show(
          ModalMapComponent,
          Object.assign(
            {},
            {
              class: 'modal-md',
              ignoreBackdropClick: true,
              initialState: {
                data
              }
            }
          )
        );
        break;
      case 'ModalVideoCallsComponent':

        this.bsModalRef = this.modalService.show(
          ModalVideoCallsComponent,
          {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            // TODO ignoreBackdropClick: true,
            initialState: {
              // @ts-ignore
              data,
              chat: data.chat,
              initStartCall: data.type
            }
          }
        );
        break;
      case 'ModalForwardMessageComponent':
        this.bsModalRef = this.modalService.show(
          ModalForwardMessageComponent,
          Object.assign(
            {},
            {
              class: 'modal-md',
              ignoreBackdropClick: true,
              initialState: {
                messages: data.messages,
                Service: data.Service,
                chatId: data.chatId
              }
            }
          )
        );
        break;
      case 'ModalNotifySettingsComponent':
        this.bsModalRef = this.modalService.show(
          ModalNotifySettingsComponent,
          Object.assign(
            {},
            {
              class: 'modal-md',
              ignoreBackdropClick: true,
              initialState: {
                chat: data.chat,
                Service: data.Service
              }
            }
          )
        );
        break;
      case 'ModalAddChatMemberComponent':
        this.bsModalRef = this.modalService.show(
          ModalAddChatMemberComponent,
          Object.assign(
            {},
            {
              class: 'modal-md',
              ignoreBackdropClick: true,
              initialState: {
                chatId: data.chatId,
                Service: data.Service
              }
            }
          )
        );
        break;
      case 'ModalCopyTextComponent':
        this.bsModalRef = this.modalService.show(
          ModalCopyTextComponent,
          Object.assign(
            {},
            {
              class: 'modal-md',
              ignoreBackdropClick: true,
              initialState: {
                text: data.text
              }
            }
          )
        );
        break;
      case 'ModalAddAccountComponent':
        this.bsModalRef = this.modalService.show(
          ModalAddAccountComponent,
          Object.assign(
            {},
            {
              class: 'modal-lg',
              ignoreBackdropClick: true,
              initialState: {
                modalMode: true
              }
            }
          )
        );
        break;
      case 'ModalMessagePinnedComponent':
        this.bsModalRef = this.modalService.show(
          ModalMessagePinnedComponent,
          Object.assign(
            {},
            {
              class: 'modal-sm',
              ignoreBackdropClick: true,
              initialState: {
                Service: data.Service,
                messages: data.messages,
                title: data.title
              }
            }
          )
        );
        break;
      case 'ModalSerrosContactsComponent':
        this.bsModalRef = this.modalService.show(
          ModalSerrosContactsComponent,
          Object.assign(
            {},
            {
              class: 'modal-md',
              ignoreBackdropClick: true,
              initialState: {
                Service: data.Service,
                sender: data.sender
              }
            }
          )
        );
        break;
      case 'ModalResultContactsComponent':
        this.bsModalRef = this.modalService.show(
          ModalResultContactsComponent,
          Object.assign(
            {},
            {
              class: 'modal-lg',
              ignoreBackdropClick: true,
              initialState: {
                Service: data.Service,
                sender: data.sender
              }
            }
          )
        );
        break;
      case 'ModalAddBalanceComponent':
        this.bsModalRef = this.modalService.show(
          ModalAddBalanceComponent,
          Object.assign(
            {},
            {
              class: 'modal-sm',
              ignoreBackdropClick: true,
              initialState: {}
            }
          )
        );
        break;
      case 'ModalLeadsTariffComponent':
        this.bsModalRef = this.modalService.show(
          ModalLeadsTariffComponent,
          Object.assign(
            {},
            {
              class: 'modal-lg',
              ignoreBackdropClick: true,
              initialState: {}
            }
          )
        );
        break;
      case 'ModalFirstFaqVideoComponent':
        this.bsModalRef = this.modalService.show(
          ModalFirstFaqVideoComponent,
          Object.assign(
            {},
            {
              class: 'modal-lg',
              ignoreBackdropClick: true,
              initialState: {}
            }
          )
        );
        break;
      case 'ModalSenderRegisterComponent':
        this.bsModalRef = this.modalService.show(
          ModalSenderRegisterComponent,
          Object.assign(
            {},
            {
              class: 'modal-md',
              ignoreBackdropClick: true,
              initialState: {}
            }
          )
        );
        break;
      case 'FaqParseComponent':
        this.bsModalRef = this.modalService.show(
          FaqParseComponent,
          Object.assign(
            {},
            {
              class: 'modal-lg',
              ignoreBackdropClick: false,
              initialState: {}
            }
          )
        );
        break;
      case 'FaqPostComponent':
        this.bsModalRef = this.modalService.show(
          FaqPostComponent,
          Object.assign(
            {},
            {
              class: 'modal-lg',
              ignoreBackdropClick: false,
              initialState: {}
            }
          )
        );
        break;
      case 'SendLimitComponent':
        this.bsModalRef = this.modalService.show(
          SendLimitComponent,
          Object.assign(
            {},
            {
              class: 'modal-md',
              ignoreBackdropClick: false,
              initialState: {}
            }
          )
        );
        break;
      case 'BanAccountsComponent':
        this.bsModalRef = this.modalService.show(
          BanAccountsComponent,
          Object.assign(
            {},
            {
              class: 'modal-lg',
              ignoreBackdropClick: false,
              initialState: {}
            }
          )
        );
        break;
      case 'LeadsScanTasksEditModalComponent':
        this.bsModalRef = this.modalService.show(
          LeadsScanTasksEditModalComponent,
          Object.assign(
            {},
            {
              class: 'modal-lg',
              ignoreBackdropClick: true,
              initialState: {
                leadTask: data.leadTask,
                copy: data?.copy
              }
            }
          )
        );
        break;
    }

    this.arModals[content] = {
      data
    };
  }

  closeModal(content) {
    if (!isUndefined(this.arModals[content])) {
      this.arModals[content].ref.close();
    }
  }

  addAccount(Service: IMessengerConnector) {
    this.openModal('ModalAddAccountComponent', {Service});
    // TODO this.showMobileHome = false;
  }
}
